import config from '../widget-config';
import { MegawidgetSComponent } from './megawidget-s.component/megawidget-s.component';
import { MegawidgetMComponent } from './megawidget-m.component/megawidget-m.component';
import { MegawidgetLComponent } from './megawidget-l.component/megawidget-l.component';
import { MegawidgetXLComponent } from './megawidget-xl.component/megawidget-xl.component';
import getWindowSize from '../../../helpers/window-resize';
import WidgetSizeHelper from '../../../helpers/widget-size-helper';

export const AutomaticComponent = () => {
    const [width, height] = getWindowSize();

    if (config.AUTOMATIC_RESIZE) {
        if (width < WidgetSizeHelper.S.maxWidth) {
            return <MegawidgetSComponent />
        }
        else if (width >= WidgetSizeHelper.M.minWidth && width < WidgetSizeHelper.M.maxWidth) {
            return <MegawidgetMComponent />
        }
        else if (width >= WidgetSizeHelper.L.minWidth && width < WidgetSizeHelper.L.maxWidth) {
            return <MegawidgetLComponent />
        }
        else {
            return <MegawidgetXLComponent />
        }
    }
    return null;
}